import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { CrossFlowProvider } from './lib/CrossFlowProvider';
export { useCrossFlow, withCrossFlow, Journeys, Targets, Reasons } from './index';
export var StartProvider = function StartProvider(props) {
  return /*#__PURE__*/React.createElement(CrossFlowProvider, _extends({}, props, {
    originProduct: "start"
  }));
};
export default StartProvider;